import { format, isValid, parseISO } from "date-fns";

// For moments, not calendar days. ClickHouse sends DateTime as "yyyy-MM-dd HH:mm:ss"
// in UTC with no zone marker, so zone-less input is read as UTC; Z / offsets are respected.
export const formatDateTime = (value?: string): string => {
  if (!value) return "N/A";
  const hasZone = /Z$|[+-]\d{2}:?\d{2}$/.test(value);
  const date = parseISO(hasZone ? value : `${value}Z`);
  return isValid(date) ? format(date, "MMM d, yyyy, hh:mm:ss a") : "N/A";
};
